// extracted by mini-css-extract-plugin
export default {"dropdownContainer":"timeframeDropdown_dropdownContainer__3nRkP","dropdown":"timeframeDropdown_dropdown__AFFfv"};